<script>
import resources from './resources'

export default {
  name: 'professional-rules-index',
  mixins: [resources]
}
</script>
<template lang="pug">
page(title="Regras para Agenda Profissional", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          message='Ainda não existe nenhuma Agenda cadastrada.',
          :buttonsNext='nextStepButtonsAgenda',
          v-if="!statusAgenda")

        ul.nav.nav-tabs
          li.active
            a(href='#') Listagem
          li(v-if="statusAgenda")
            router-link(:to="{name: 'professional.agenda.rules.create'}")
             a(href="#") Cadastro
          li(v-if="!statusAgenda")
             a.mb-cursor-point(@click.prevent="show = true")
              | Cadastro

        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")
        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.agenda_name", type='text', placeholder='Buscar Regras')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 

            a.mb-cursor-point(v-if="!statusAgenda", @click.prevent="show = true")
              .add-list.mb-cursor-point
                .icon-wrapper
                  span.icon 
                  .plus
                    span.icon 
                .text
                  | Nova<br>Regra

            card-add(label='Nova<br>Regra', route='professional.agenda.rules.create', icon='', v-if="statusAgenda")
            .list-item.white-bg.list-item(v-for=("rule in rules"))
              .row.border-bottom
                h4.col-xs-8(v-tooltip="rule.agenda.name") {{ rule.agenda_name_small}}
                .col-xs-4
                  .exclude-list(@click.prevent="doDelete(rule)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: rule.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                strong {{ rule.days }}
                br
                | {{ rule.time_start }} - {{ rule.time_end }}  {{ rule.time_start_two }} - {{ rule.time_end_two }}
                br
                | Validade entre: {{ rule.valid_to_start }} - {{ rule.valid_to_end }}
                br
                | {{ rule.agenda.professional.name }}

          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/agenda/rules/index/index.vue